import { render, staticRenderFns } from "./RadioButtonBox.vue?vue&type=template&id=dbbb4c8c&scoped=true"
import script from "./RadioButtonBox.vue?vue&type=script&lang=ts"
export * from "./RadioButtonBox.vue?vue&type=script&lang=ts"
import style0 from "./RadioButtonBox.vue?vue&type=style&index=0&id=dbbb4c8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbb4c8c",
  null
  
)

export default component.exports